var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{staticClass:"edge",class:("edge-" + (_vm.from.data.id) + "-" + (_vm.to.data.id)),attrs:{"id":("edge-" + (_vm.from.data.id) + "-" + (_vm.to.data.id)),"d":_vm.path}})}
var staticRenderFns = []

export { render, staticRenderFns }